var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "admin-content-area",
      attrs: { id: "page-content-wrapper" }
    },
    [
      _c("div", { staticClass: "container-fluid xyz" }, [
        _vm._m(0),
        _vm._v(" "),
        _c("div", { staticClass: "admin-page-content" }, [
          _c("form", { attrs: { id: "benefitForm" } }, [
            _c(
              "div",
              { staticClass: "row" },
              [
                _vm._l(_vm.imagesForApproval, function(text, index) {
                  return [
                    _c(
                      "div",
                      {
                        staticClass:
                          "col-lg-12 col-md-12 col-sm-12 col-xs-12 mt-20"
                      },
                      [
                        _c("div", { staticClass: "card" }, [
                          _c("div", { staticClass: "card-body" }, [
                            _c(
                              "div",
                              {
                                staticClass:
                                  "col-lg-6 col-md-6 col-sm-12 col-xs-12"
                              },
                              [
                                _c(
                                  "a",
                                  {
                                    staticClass: "image-zoom",
                                    attrs: {
                                      href: text.image,
                                      rel: "prettyPhoto[gallery]",
                                      title: text.caption
                                    }
                                  },
                                  [
                                    _c("img", {
                                      staticClass: "img-thumbnail",
                                      attrs: { src: text.image }
                                    })
                                  ]
                                )
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "div",
                              {
                                staticClass:
                                  "col-lg-6 col-md-6 col-sm-12 col-xs-12"
                              },
                              [
                                _c("div", { staticClass: "form-group mt-15" }, [
                                  _c("p", [
                                    _vm._v(
                                      "Uploaded By : " +
                                        _vm._s(text.created_by) +
                                        " ("
                                    ),
                                    _c(
                                      "a",
                                      {
                                        staticClass: "internal-link",
                                        attrs: {
                                          target: "_blank",
                                          href:
                                            "mailto:" + text.created_by_email
                                        }
                                      },
                                      [_vm._v(_vm._s(text.created_by_email))]
                                    ),
                                    _vm._v(")")
                                  ])
                                ]),
                                _vm._v(" "),
                                _c("div", { staticClass: "form-group" }, [
                                  _c("p", [
                                    _vm._v(
                                      "Image Caption : " + _vm._s(text.caption)
                                    )
                                  ])
                                ]),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  {
                                    staticClass:
                                      "row col-lg-12 col-md-12 col-sm-12 col-xs-12"
                                  },
                                  [
                                    _c(
                                      "div",
                                      { staticClass: "form-group" },
                                      [
                                        _vm._m(1, true),
                                        _vm._v(" "),
                                        _c(
                                          "v-select",
                                          {
                                            attrs: {
                                              name: "categoryId",
                                              id: "categoryId_" + index,
                                              label: "text",
                                              filterable: false,
                                              options: _vm.categoryArr,
                                              placeholder: "Select Category"
                                            },
                                            on: {
                                              change: _vm.changedValue,
                                              input: function($event) {
                                                return _vm.changedCategoryFor(
                                                  text.id
                                                )
                                              },
                                              search: _vm.onSearchCategory
                                            },
                                            scopedSlots: _vm._u(
                                              [
                                                {
                                                  key: "option",
                                                  fn: function(option) {
                                                    return [
                                                      _c(
                                                        "div",
                                                        {
                                                          staticClass:
                                                            "d-center"
                                                        },
                                                        [
                                                          _vm._v(
                                                            "\n                                                            " +
                                                              _vm._s(
                                                                option.text
                                                              ) +
                                                              "\n                                                        "
                                                          )
                                                        ]
                                                      )
                                                    ]
                                                  }
                                                },
                                                {
                                                  key: "selected-option",
                                                  fn: function(option) {
                                                    return [
                                                      _c(
                                                        "div",
                                                        {
                                                          staticClass:
                                                            "selected d-center"
                                                        },
                                                        [
                                                          _vm._v(
                                                            "\n                                                            " +
                                                              _vm._s(
                                                                option.text
                                                              ) +
                                                              "\n                                                        "
                                                          )
                                                        ]
                                                      )
                                                    ]
                                                  }
                                                }
                                              ],
                                              null,
                                              true
                                            ),
                                            model: {
                                              value: _vm.categoryId[text.id],
                                              callback: function($$v) {
                                                _vm.$set(
                                                  _vm.categoryId,
                                                  text.id,
                                                  $$v
                                                )
                                              },
                                              expression: "categoryId[text.id]"
                                            }
                                          },
                                          [
                                            _c(
                                              "template",
                                              { slot: "no-options" },
                                              [
                                                _vm._v(
                                                  "\n                                                        Search Category...\n                                                    "
                                                )
                                              ]
                                            )
                                          ],
                                          2
                                        ),
                                        _vm._v(" "),
                                        _c("font", {
                                          staticClass: "text-danger",
                                          attrs: {
                                            id: "categoryIdErrors_" + text.id
                                          }
                                        })
                                      ],
                                      1
                                    )
                                  ]
                                ),
                                _vm._v(" "),
                                _c("div", { staticClass: "clearfix" }),
                                _vm._v(" "),
                                _c("br"),
                                _vm._v(" "),
                                _c("div", { staticClass: "row clearfix" }, [
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "col-lg-12 col-md-12 col-sm-12 col-xs-12"
                                    },
                                    [
                                      _c(
                                        "div",
                                        {
                                          staticClass: "alert",
                                          attrs: { id: "alertError_" + text.id }
                                        },
                                        [
                                          _c("strong", {
                                            staticClass: "error",
                                            attrs: { id: "errorMsg_" + text.id }
                                          })
                                        ]
                                      )
                                    ]
                                  )
                                ]),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  {
                                    staticClass:
                                      "row col-lg-12 col-md-12 col-sm-12 col-xs-12"
                                  },
                                  [
                                    _c("div", { staticClass: "form-group" }, [
                                      _c(
                                        "button",
                                        {
                                          staticClass: "btn btn-primary",
                                          attrs: { id: "addMedia" },
                                          on: {
                                            click: function($event) {
                                              $event.preventDefault()
                                              return _vm.updateMedia(text.id, 1)
                                            }
                                          }
                                        },
                                        [_vm._v("Approve")]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "button",
                                        {
                                          staticClass: "btn btn-danger",
                                          attrs: { id: "removeAll" },
                                          on: {
                                            click: function($event) {
                                              $event.preventDefault()
                                              return _vm.deleteDayforceDocSection(
                                                text.id
                                              )
                                            }
                                          }
                                        },
                                        [_vm._v("Reject")]
                                      )
                                    ])
                                  ]
                                )
                              ]
                            ),
                            _vm._v(" "),
                            _c("div", { staticClass: "clearfix" })
                          ])
                        ])
                      ]
                    )
                  ]
                })
              ],
              2
            )
          ])
        ])
      ]),
      _vm._v(" "),
      _c("app-backend-footer")
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "page-header-top-container" }, [
      _c("div", { staticClass: "page-name" }, [
        _vm._v("\n                Images For Approval\n            ")
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("label", { attrs: { for: "categories" } }, [
      _vm._v("Category"),
      _c("span", { staticClass: "text-danger" }, [_vm._v("*")])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-3d388abb", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3d388abb","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/backend/gallery/ImageListForApproval.vue
// module id = null
// module chunks = 